import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

import FallbackPage from '../LandingPage/FallbackPage';
import { ASSET_NAME, formatCountry } from './CountryLandingPage.duck';
import './CountryLandingPage.module.css';
import { useParams } from 'react-router-dom';
import NotFoundPage from '../NotFoundPage/NotFoundPage';
import { NON_COUNTRY_REGIONS } from '../../constants';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const LandingPageComponent = props => {
  const { pageAssetsData, inProgress, error } = props;
  const { country } = useParams() || {};
  const formattedCountry = formatCountry(country);

  const nonCountryRegionsFormatted = NON_COUNTRY_REGIONS.map(region => region.toLowerCase().replace(/\s+/g, '-'));
  if (nonCountryRegionsFormatted.includes(formattedCountry)) {
    return <NotFoundPage />
  }

  return (
    <PageBuilder
      pageAssetsData={pageAssetsData?.[camelize(formattedCountry)]?.data}
      inProgress={inProgress}
      error={error}
      fallbackPage={<FallbackPage error={error} />}
    />
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CountryLandingPage = compose(connect(mapStateToProps))(LandingPageComponent);

export default CountryLandingPage;
